import React from 'react';
import Success from '../../../assets/svgs/success.svg';

interface PayoutRequestSuccessProps {
  onNegotiateRate: () => void;
}

const PayoutRequestSuccess: React.FC<PayoutRequestSuccessProps> = () => {
  return (
    <div className="mt-6 flex flex-col items-center justify-center gap-8 rounded-xl border border-[#F1F2F4] p-8 ">
      <img src={Success} alt="" className="w-[120px] h-[120px]" />

      <div className="flex flex-col items-center justify-center gap-3">
        <p className="text-[#1F2937] text-[32px] leading-10 font-bold ">
          Payout Request Submitted!
        </p>
        <p className="text-[#687588] text-lg font-normal">
          Your payout request has been successfully submitted and is being
          processed.
        </p>
      </div>

      {/* <div className="w-full bg-[#F8F8F8] border-[#EEEFF2] border p-8 rounded-3xl items-center justify-center flex flex-col gap-4">
        <p className="text-[#323B49] font-semibold text-xl ">
          Transaction Details
        </p>
        <div className="flex gap-6">
          <div className="flex flex-col gap-1">
            <p className="text-[#848A96] font-normal text-sm">
              Reference Number
            </p>
            <p className="text-[#111827] font-bold text-lg">TX7HIRW2WX2</p>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-[#848A96] font-normal text-sm">
              Reference Number
            </p>
            <p className="text-[#111827] font-bold text-lg">TX7HIRW2WX2</p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default PayoutRequestSuccess;
